import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ResponseRelacionModule, ReponseRelacionAlmacenModule } from '../../../core/model/response-relacion.module';
import { ToastrService } from 'ngx-toastr';
import { InventariosService } from '../../../core/services/inventarios.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResizedEvent } from '../../../core/model/resized-event';
import { SeriesService } from '../../../core/services/series.service';
import { BsModalService } from 'ngx-bootstrap';
import { ModalShowTextComponent } from '../../../utils/modal-show-text/modal-show-text.component';
import { TranslateService } from '@ngx-translate/core';
import { FileData } from '../../../core/model/massive-load-result';
import { environment } from '../../../../environments/environment';
import { FieldsWithDataToPaintModule } from '../../../core/model/fields-with-data-to-paint.module';
import { MenuimpresiondocumentosComponent } from '../../../utils/menuimpresiondocumentos/menuimpresiondocumentos.component';
import { AlbaranService } from '../../../core/services/albaran.service';
import { PdfService } from '../../../core/services/pdf.service';

@Component({
  selector: 'app-relaciones-almacen',
  templateUrl: './relaciones-almacen.component.html',
  styleUrls: ['./relaciones-almacen.component.css']
})
export class RelacionesAlmacenComponent implements OnInit, OnChanges {

  constructor(
    private toastr: ToastrService,
    private inventariosService: InventariosService,
    private serieService: SeriesService,
    private modalService: BsModalService,
    private translateService: TranslateService,
    private documentService: AlbaranService,
    private pdfService: PdfService
  ) { }



  @Input() idContenido = 0;
  @Input() idSolicitud = 0;
  @Input() serieSolicitud = 0;
  @Input() readOnly = false;
  @Output() public relacionesLocalizadasEvent = new EventEmitter<any>();
  relacionesAlmacen: FieldsWithDataToPaintModule[] = [];
  loading = true;
  message = 'Cargando';
  @ViewChild('table') table: any;

  columns = [];

  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  customMessages = {
    emptyMessage: 'No hay relaciones disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'idContenido' && changes[propName].previousValue !== undefined) {
        this.recuperarDatosRelaciones();
        return;
      }
    }
  }

  ngOnInit() {
    this.recuperarDatosRelaciones();
  }

  addFileConsulta(idRelacion, File) {
    const fileToSave = this.createFileDataFromRaw(File.target.files[0]);
    if (fileToSave.extension.toLowerCase() !== 'pdf') {
      this.toastr.warning(this.translateService.instant('consultas.solopdf'));
      return;
    }
    if (File.target.files[0].size > environment.MAX_FILESIZE) {
      this.toastr.warning(this.translateService.instant('consultas.longitudmaxima') + ` ${environment.MAX_FILESIZE} KB.`);
      return;
    }
    this.message = 'Subiendo fichero';
    this.loading = true;
    this.inventariosService.addImageToConsulta(idRelacion, fileToSave.file)
      .subscribe(
        (r: boolean) => {
          if (r) {
            this.toastr.success(this.translateService.instant('consultas.addedImagen'));
          } else {
            this.toastr.error(this.translateService.instant('consultas.errorSubidaImagen'));
          }
          this.recuperarDatosRelaciones();
          this.loading = false;
        },
        () => {
          this.toastr.error(this.translateService.instant('consultas.errorServicioSubirImagen'));
          this.loading = false;
        }
      );
  }

  downloadFileConsulta(idRelacion: number, nameFile: string) {
    this.message = 'Descargando fichero';
    this.loading = true;
    this.inventariosService.descargarImagenConsulta(idRelacion)
      .subscribe(
        data => {
          this.loading = false;
          this._saveAs(nameFile, data);
        },
        () => {
          this.toastr.error(this.translateService.instant('consultas.downloadfailed'));
          this.loading = false;
        }
      );
  }

  removeConsulta(imagen: string) {
    this.message = 'Eliminando fichero';
    this.loading = true;
    this.inventariosService.removeImagenConsulta(imagen)
      .subscribe(
        data => {
          this.loading = false;
          this.toastr.success(this.translateService.instant('consultas.removeimagenok'));
          this.recuperarDatosRelaciones();
        },
        () => {
          this.toastr.error(this.translateService.instant('consultas.removeimagenerror'));
          this.loading = false;
        }
      );
  }

  private _saveAs(fileName: string, data: any) {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    const blob = new Blob([data], { type: 'application/octet-stream' });
    let objectUrl = '';
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // save file for IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // save for other browsers: Chrome, Firefox
      objectUrl = URL.createObjectURL(blob);
      // window.open(objectUrl);
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
    }
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  createFileDataFromRaw(file): FileData {
    const toReturn = new FileData();
    toReturn.filename = file.name;
    toReturn.extension = this.inventariosService.getExtension(file.name);
    toReturn.size = this.inventariosService.calculateSizeFile(file.size);
    toReturn.file = file;
    return toReturn;
  }

  getRowClassDefault = (row) => {
    return { 'datatable-body-row bg-success': row.DEFAULT };
  }

  getValue(fila: FieldsWithDataToPaintModule, col): string {
    if (fila.fieldsToPaint.length > 0) {
      const toReturn = fila.fieldsToPaint.filter(p => p.nombreCampo === col.name)[0].descripcionCampo;
      return toReturn;
    }
    return '';
  }

  private emitirEventoCambio() {
    this.relacionesLocalizadasEvent.emit(
      {
        cantidadLocalizadas: this.relacionesAlmacen.filter(p => p.localizado).length,
        cantidadNoLocalizadas: this.relacionesAlmacen.filter(p => !p.localizado).length,
        cantidadConsultas: this.relacionesAlmacen.length
      });
  }

  recuperarDatosRelaciones() {
    this.message = this.translateService.instant('consultas.recoverrelaciones') + this.idContenido;
    this.loading = true;
    this.inventariosService.getRelacionesContenido(this.idContenido)
      .subscribe(
        (r: any) => {
          this.relacionesAlmacen = r;
          this.emitirEventoCambio();
          if (this.relacionesAlmacen.length > 0) {
            this.columns = this.relacionesAlmacen[0].fieldsToPaint.map(p => ({ name: p.nombreCampo }));
          }
        },
        () => this.toastr.error(this.translateService.instant('consultas.errorecoverelaciones')),
        () => this.loading = false
      );
  }

  getTitleButtonDevolucion(row): string {
    if (!row.pendienteDevolucion) {
      return this.translateService.instant('consultas.titlebuttondevolucionyadevuelto');
    }
    return this.translateService.instant('consultas.titlebuttondevolucion');
  }

  refreshData() {
    this.recuperarDatosRelaciones();
  }

  onResized(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  printConsulta(consulta: number, disabledTestigo: boolean) {
    const modal = this.modalService.show(MenuimpresiondocumentosComponent, { class: 'modal-lg' });
    (<MenuimpresiondocumentosComponent>modal.content).showTextModal(disabledTestigo);
    (<MenuimpresiondocumentosComponent>modal.content).onPrintLocation.subscribe(
      (r) => {
        (<MenuimpresiondocumentosComponent>modal.content).showLoading(true);
        this.documentService.impresionLocation(this.idContenido)
          .subscribe(p => {
            (<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada = p;
            (<MenuimpresiondocumentosComponent>modal.content).showLoading(false);
          });
      }
    );
    (<MenuimpresiondocumentosComponent>modal.content).onPrintAlbaran.subscribe(
      (r) => {
        (<MenuimpresiondocumentosComponent>modal.content).showLoading(true);
        this.documentService.impresionAlbaran(this.idContenido)
          .subscribe(p => {
            (<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada = p;
            (<MenuimpresiondocumentosComponent>modal.content).showLoading(false);
          });
      }
    );
    (<MenuimpresiondocumentosComponent>modal.content).onPrintCartela.subscribe(
      (r) => {
        (<MenuimpresiondocumentosComponent>modal.content).showLoading(true);
        this.documentService.impresionCartela(this.idContenido, consulta)
          .subscribe(p => {
            (<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada = p;
            (<MenuimpresiondocumentosComponent>modal.content).showLoading(false);
          });
      }
    );
    (<MenuimpresiondocumentosComponent>modal.content).onPrintTestigo.subscribe(
      (r) => {
        (<MenuimpresiondocumentosComponent>modal.content).showLoading(true);
        this.documentService.impresionTestigo(this.idContenido, consulta)
          .subscribe(p => {
            (<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada = p;
            (<MenuimpresiondocumentosComponent>modal.content).showLoading(false);
          });
      }
    );
    (<MenuimpresiondocumentosComponent>modal.content).onPrintPeticionPalet.subscribe(
      (r) => {
        (<MenuimpresiondocumentosComponent>modal.content).showLoading(true);
        this.documentService.impresionPeticionPalet(this.idContenido)
          .subscribe(p => {
            (<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada = p;
            (<MenuimpresiondocumentosComponent>modal.content).showLoading(false);
          });
      }
    );
    (<MenuimpresiondocumentosComponent>modal.content).onPrintAll.subscribe(
      (r) => {
        (<MenuimpresiondocumentosComponent>modal.content).showLoading(true);
        this.documentService.impresionTodo(this.idContenido, consulta)
          .subscribe(p => {
            (<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada = p;
            (<MenuimpresiondocumentosComponent>modal.content).showLoading(false);
          });
      }
    );
    (<MenuimpresiondocumentosComponent>modal.content).onPrintPrinter.subscribe(
      (r) => {
        this.printpdf((<MenuimpresiondocumentosComponent>modal.content).ArrayEntrada);
      }
    );
  }

  printpdf(arrayEntrada?: ArrayBuffer) {
    if (arrayEntrada !== null) {
      const blob = new Blob([arrayEntrada], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const argumentos = {
        printable: blobUrl,
        type: 'pdf',
        showModal: true,
        modalMessage: 'Recuperando documento',
        arrayBuffer: arrayEntrada
      };
      // printJS(argumentos);
      this.pdfService.printJS(argumentos);

    }
  }

  showModalObsParcial(idRelacion: number, textoParcial: string) {
    const modalTitle = 'consultas.modifparcial';
    const modalTextConfirm = 'consultas.saveparcial';
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      textoParcial,
      modalTextConfirm,
      this.readOnly,
      null,
      2000
    );
    (<ModalShowTextComponent>modal.content).onClose.subscribe((result: string) => {
      if (result !== undefined && result !== null && result != '' && result !== textoParcial) {
        this.loading = true;
        this.inventariosService.modifTextoParcialRelacion(idRelacion, result)
          .subscribe(
            (r: boolean) => {
              if (!r) {
                this.toastr.error(this.translateService.instant('consultas.parcialnoguardado'));
              } else {
                this.toastr.success(this.translateService.instant('consultas.parcialguardado'));
                this.recuperarDatosRelaciones();
              }
              this.loading = false;
            },
            () => {
              this.toastr.error(this.translateService.instant('consultas.errorparcial'));
              this.loading = false;
            }
          );
      }
    });
  }

  showModalObservaciones(idRelacion: number, observacion: string) {
    const modalTitle = 'observacionrelacion.observacionesrelacion';
    const modalTextConfirm = 'observacionrelacion.saveobservacion';
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      observacion,
      modalTextConfirm,
      this.readOnly,
      true,
      1024
    );
    (<ModalShowTextComponent>modal.content).onClose.subscribe((result: string) => {
      if (result !== undefined && result !== null && result != '') {
        this.loading = true;
        this.inventariosService.setObservacion(idRelacion, result)
          .subscribe(
            (r: boolean) => {
              if (!r) {
                this.toastr.error(this.translateService.instant('observacionrelacion.respuestaservicionook'));
              } else {
                this.toastr.success(this.translateService.instant('observacionrelacion.respuestaserviciook'));
                this.recuperarDatosRelaciones();
              }
              this.loading = false;
            },
            () => {
              this.toastr.error(this.translateService.instant('observacionrelacion.respuestaservicioerror'));
              this.loading = false;
            }
          );
      }
    });
  }

  getLiteralTipo(tipo: number): string {
    switch (tipo) {
      case 0:
        return 'Préstamo expediente';
      case 1:
        return 'Parcial expediente';
      case 2:
        return 'Contenedor';
      case 3:
        return 'Parcial contenedor';
    }
  }

  getLiteralLocalizado(localizado: number): string {
    if (localizado === 1) {
      return 'Localizado';
    } else {
      return 'No localizado';
    }
  }

  gotoExpediente(idExpediente) {
    this.inventariosService.goToRecordDetailById(idExpediente);
  }

  gotoContenedor(idContenedor) {
    this.inventariosService.goToContainers(idContenedor);
  }

  gotoAddConsulta() {
    this.inventariosService.goToExpedientesActivandoConsultas(
      this.idSolicitud,
      this.idContenido,
      this.relacionesAlmacen.map((p) => {
        if (p.GUID_EXPEDIENTE === undefined || p.GUID_EXPEDIENTE === null) {
          return p.ID_CONTENEDOR.toString();
        } else {
          return p.GUID_EXPEDIENTE;
        }
      } )
    );
  }

  gotoDocument(row: ReponseRelacionAlmacenModule) {
    if (row.GUID_EXPEDIENTE == undefined || row.GUID_EXPEDIENTE == null) {
      this.gotoContenedor(row.ID_CONTENEDOR);
    } else {
      this.gotoExpediente(row.GUID_EXPEDIENTE);
    }
  }

  marcarLocalizadoUD(idUDRelacion, localizado: boolean) {
    this.message = 'Marcando el expediente como ' + (localizado ? 'localizado' : 'no localizado');
    this.loading = true;
    this.inventariosService.tagLocalizadoONoRelacion(idUDRelacion, localizado)
      .subscribe(
        (r) => {
          if (!r) {
            this.toastr.warning('El servidor ha devuelto que no se ha podido marcar el cambio de localización en la linea. ' +
              'Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
          } else {
            this.toastr.success('Se ha marcado el expediente o contenedor como ' + (localizado ? 'localizado' : 'no localizado'));
            this.recuperarDatosRelaciones();
          }
        },
        () => this.toastr.error('Ha ocurrido un error en la peticion al servidor'),
        () => this.loading = false
      );
  }

  marcarLocalizadoRelacion(idRelacion, localizado: boolean) {
    this.message = 'Marcando todas las relaciones como ' + (localizado ? 'localizado' : 'no localizado');
    this.loading = true;
    this.inventariosService.tagLocalizadoONoRelacion(idRelacion, localizado)
      .subscribe(
        (r) => {
          if (!r) {
            this.toastr.warning('El servidor ha devuelto que no se ha podido marcar el cambio de localización en las lineas del contenido. ' +
              'Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
          } else {
            this.toastr.success('Se han marcado las lineas de relación como ' + (localizado ? 'localizado' : 'no localizado'));
            this.recuperarDatosRelaciones();
          }
        },
        () => this.toastr.error('Ha ocurrido un error en la peticion al servidor'),
        () => this.loading = false
      );
  }

  devolverconsulta(idconsulta: number) {
    this.message = 'Realizando devolución de la consulta ' + idconsulta;
    this.loading = true;
    this.inventariosService.getDevolucionConsulta(idconsulta)
      .subscribe(
        (p) => {
          if (p === 0) {
            this.toastr.warning('No se ha marcado correctamente la consulta como devuelta');
          } else {
            this.toastr.success('Se ha marcado como devuelto correctamente la consulta ' + p);
          }
          this.loading = false;
          this.recuperarDatosRelaciones();
        },
        () => {
          this.toastr.error('Ha ocurrido un error al marcar la consulta como devuelta');
          this.loading = false;
        }
      );
  }

}
